// extracted by mini-css-extract-plugin
module.exports = {"marker":"SentimentMarker_marker__3KIHQ","circle":"SentimentMarker_circle__1Blzs","glyph":"SentimentMarker_glyph__37JAM"};